import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import { getMarketoFormId } from 'utils/marketo';
import { testDemo5 } from 'utils/intellimize';
import MarketoForm from 'components/Form/MarketoForm';
import useDefaultDemoForm from 'hooks/useDefaultDemoForm';
import { MarketingFormModal } from './styles';
import adImage from 'images/tmp-demo-modal.png';
import './modal-responsive.less';

const ModalMarketingForm = ({
  dataPosition,
  formType,
  isModalOpen,
  onModalOk,
  onModalCancel,
  onFormSuccess,
  formButtonLabel,
  formTitle,
  termsText,
  redirectUrl,
  closable = true,
  shouldRedirect = true,
  keyboardClose,
  useEmbeddedForm,
  useCustomDqFlow,
  ...props
}) => {
  const inlineMarketingForm = props.inlineMarketingForm || useDefaultDemoForm();
  const marketoId = parseInt(getMarketoFormId(inlineMarketingForm.marketoForm), 10);
  const isProfilingSubmission = Cookies.get(`marketo_form_${marketoId}_submit`) || false;
  const demoForm5Style = Cookies.get('demo_form_style_5') === 'true';

  if (isModalOpen && isProfilingSubmission !== false) {
    const dataLayerData = JSON.parse(isProfilingSubmission);
    dataLayer.push(dataLayerData);
    onFormSuccess();
  }

  useEffect(() => {
    testDemo5();
  }, []);

  return (
    <MarketingFormModal
      className={`modal-marketing-form--modal ${demoForm5Style ? 'demo-form-style--5' : ''}`}
      visible={isModalOpen && !isProfilingSubmission}
      closable={closable}
      footer={null}
      maskClosable={false}
      bodyStyle={{ padding: 0 }}
      onCancel={onModalCancel}
      keyboard={keyboardClose}
      adImage={adImage}
      width={600}
    >
      <div className="modal-marketing-form--container">
        <div className="modal-marketing-form--ad-container">
          <div className="modal-marketing-form--ad-img" />
        </div>
        <div className="modal-marketing-form--form-container">
          <MarketoForm
            data-testid={`modal-marketing-form-${marketoId}`}
            dataPosition={dataPosition || 'Modal Form'}
            formType={formType}
            inlineMarketingForm={inlineMarketingForm}
            buttonLabel={formButtonLabel}
            onSuccess={onFormSuccess}
            shouldRedirect={shouldRedirect}
            closeModal={onModalCancel}
            titleSize="30px"
            title={formTitle}
            termsText={termsText}
            redirectUrl={redirectUrl}
            useEmbeddedForm={useEmbeddedForm}
            useCustomDqFlow={useCustomDqFlow}
            demoForm5Style={demoForm5Style}
            isModalForm
          />
        </div>
      </div>
    </MarketingFormModal>
  );
};

export default ModalMarketingForm;
